import * as React from 'react'

import { fieldHasError } from '../../utils/validation'
import { colors, fonts } from '../../utils/style'

type Props = {
  name: string
  formProps: any
  forceErrorVisibility?: boolean
}

export default function FieldError({
  name,
  formProps,
  forceErrorVisibility,
}: Props) {
  return fieldHasError(name, formProps, forceErrorVisibility) ? (
    <div className="root">
      {formProps.errors[name]}

      <style jsx>{`
        .root {
          font-family: ${fonts.IBMPlex};
          font-size: 16px;
          line-height: 21px;
          font-weight: normal;

          color: ${colors.red};
        }
      `}</style>
    </div>
  ) : null
}
